module.exports = __webpack_public_path__ + "media/images/h3_bg-5f462f5dcadba64591051df824452491.gif";